import { atom } from "jotai";
import type { User } from "../data/schema";

export type UsersDialogType = "invite" | "delete" | "delete_all" | null;

export const usersDialogAtom = atom<UsersDialogType>(null);
export const usersCurrentRowAtom = atom<User | null>(null);
